import { motion } from "framer-motion";
import { Check, X } from "lucide-react";
import { Eyebrow, Reveal, stagger, fadeUp } from "./motion";
import { WHO_FOR } from "../config/content";

export default function WhoFor() {
  return (
    <section className="py-16 md:py-24" data-testid="who-for-section">
      <div className="max-w-[1180px] mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>{WHO_FOR.eyebrow}</Eyebrow>
          <h2 className="font-heading uppercase text-white text-4xl sm:text-5xl leading-none tracking-wide max-w-3xl" data-testid="who-for-heading">
            {WHO_FOR.titleA} <span className="text-[#22C55E]">{WHO_FOR.titleHighlight}</span>
          </h2>
        </Reveal>
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="mt-10 grid md:grid-cols-2 gap-4 md:gap-6"
        >
          <motion.div variants={fadeUp} className="card-hover rounded-2xl bg-[#0F1712] border border-[#22C55E]/40 p-6 sm:p-8 shadow-[0_0_50px_-18px_rgba(34,197,94,0.3)]" data-testid="for-you-card">
            <h3 className="font-heading uppercase text-[#22C55E] text-2xl sm:text-3xl tracking-wide">{WHO_FOR.forYou.title}</h3>
            <ul className="mt-6 space-y-4">
              {WHO_FOR.forYou.items.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-[#22C55E] shrink-0 mt-0.5" strokeWidth={3} />
                  <p className="text-sm sm:text-base text-[#A7B3AA] leading-relaxed">{item}</p>
                </li>
              ))}
            </ul>
          </motion.div>
          <motion.div variants={fadeUp} className="card-hover rounded-2xl bg-[#120B0B] border border-[#EF4444]/30 p-6 sm:p-8" data-testid="not-for-you-card">
            <h3 className="font-heading uppercase text-[#EF4444] text-2xl sm:text-3xl tracking-wide">{WHO_FOR.notForYou.title}</h3>
            <ul className="mt-6 space-y-4">
              {WHO_FOR.notForYou.items.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <X className="w-5 h-5 text-[#EF4444] shrink-0 mt-0.5" strokeWidth={3} />
                  <p className="text-sm sm:text-base text-[#A7B3AA] leading-relaxed">{item}</p>
                </li>
              ))}
            </ul>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
